import React from 'react';
import useGetClassDescriptions from './useGetClassDescriptions';
import type { ProductTypes } from '../../../securityQuestionsSchema/securityQuestionSchema';

type Params = {
  accountId: string;
  industryCode: string | number | undefined;
  productType: ProductTypes;
  effectiveDate?: string | null;
  productVersion?: number | null;
  state?: string | null;
};

const useClassDescriptionOptions = ({
  industryCode,
  productType,
  effectiveDate,
  productVersion,
  state,
}: Params) => {
  const classDescriptionsQuery = useGetClassDescriptions({
    productType,
    industryCode,
    effectiveDate,
    productVersion,
    state,
  });

  const options = React.useMemo(() => {
    if (!classDescriptionsQuery.data) {
      return [];
    }

    return classDescriptionsQuery.data.map((option) => ({
      label: option.description,
      value: option.id,
      meta: {
        id: option.id,
        code: option.code,
        description: option.description,
        hazardClassId: option.hazardClass.id,
        hazardClassCode: option.hazardClass.code,
      },
    }));
  }, [classDescriptionsQuery.data]);

  return {
    options,
    isLoading: classDescriptionsQuery.isLoading,
  };
};

export default useClassDescriptionOptions;
